<template>
  <div id="dropdown-action-group">
    <v-select
      v-model="formData.nextstepType"
      class="v-select-filter bg-dropdown p-0"
      placeholder="Status"
      :searchable="true"
      :reduce="(option) => option.value"
      :options="tagOption.sectionOption"
      :clearable="false"
    />
  </div>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";

export default {
  props: {
    formData: { type: Object, default: null },
  },
  setup(props) {
    let tagOption = reactive({
      sectionOption: [],
      changeStepType: null,
    });

    const onSetTagOption = () => {
      tagOption.sectionOption = props.formData.nextstepOption.map((obj) => ({
        ...obj,
        value: obj.next_sectionid ? obj.next_sectionid : obj.nextstep_type,
        label: obj.nextstep_desc,
      }));

      tagOption.changeStepType = props.formData.nextstepOption.filter(
        (o) => o.next_sectionid == props.formData.nextstepType
      );
    };

    watch(
      () => props.formData.nextstepOption,
      () => {
        onSetTagOption();
      },
      { deep: true }
    );

    onBeforeMount(() => {
      onSetTagOption();
    });

    return {
      tagOption,
    };
  },
};
</script>

<style>
@import "~@/assets/css/override-styles/v-select.css";
#dropdown-action-group .bg-dropdown {
  background-color: transparent !important;
}

#dropdown-action-group .bg-dropdown > div {
  border-radius: 0 !important;
  border-color: transparent transparent #a7a7a7 transparent !important;
  height: 26px;
}

#dropdown-action-group .vs--single .vs__dropdown-toggle {
  padding-left: 0 !important;
  cursor: pointer;
}

#dropdown-action-group .vs__actions {
  position: relative;
  left: 28px;
  background-color: #e8ebf1;
  border-radius: 5px;
  height: 26px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 3px 0 3px !important;
  cursor: pointer;
}

#dropdown-action-group .vs--open .vs__dropdown-toggle {
  background-color: transparent !important;
  box-shadow: none !important;
  height: 26px;
}

#dropdown-action-group .v-select-filter input {
  height: 20px;
}

#dropdown-action-group .vs__open-indicator {
  color: #728aac;
  fill: #728aac;
  margin-top: 0 !important;
}

#dropdown-action-group .v-select.vs--single .vs__selected {
  margin-top: -7px !important;
  width: 20px;
}

#dropdown-action-group .vs--single.vs--open .vs__selected {
  margin-top: -7px !important;
}

#dropdown-action-group .v-select-filter {
  height: 30px;
  width: 230px !important;
}

#dropdown-action-group .vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100% - 25px);
}

#dropdown-action-group .vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

#dropdown-action-group .v-select.vs--single .vs__selected {
  height: 30px;
  margin-top: -6px !important;
  width: 100%;
  padding-right: 0 !important;
}

#survey-item #link-to-choice ul.vs__dropdown-menu > li,
#survey-item #link-to-choice ul.vs__dropdown-menu > li:hover {
  display: flex;
  width: 100%;
}

#dropdown-action-group ul.vs__dropdown-menu > li.vs__dropdown-option--selected,
#dropdown-action-group
  ul.vs__dropdown-menu
  > li.vs__dropdown-option--selected:hover {
  color: #fff !important;
  width: calc(100% + 10%);
}

#dropdown-action-group .vs__search,
#dropdown-action-group .vs__search:focus {
  font-size: 21px !important;
  margin-top: -1px;
  padding: 0 !important;
}
</style>